import { FormField } from '@/components/templates/entity-form'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type {
  MembershipLevelForm,
  RenewalStructure,
  RenewalTerm,
} from '@/pages/MembershipLevelsPage.types'
import { renewalStructures, renewalTerms } from '@/pages/MembershipLevelsPage.types'

export function MembershipLevelProrationSettings({
  form,
  onChange,
}: {
  form: MembershipLevelForm
  onChange: (form: MembershipLevelForm) => void
}) {
  return (
    <div className="flex items-start gap-2">
      <Checkbox
        id="membership-level-prorate-first-partial-period"
        checked={form.prorateFirstPartialPeriod}
        onCheckedChange={(checked) =>
          onChange({ ...form, prorateFirstPartialPeriod: checked === true })
        }
      />
      <Label htmlFor="membership-level-prorate-first-partial-period" className="text-foreground">
        Prorate first partial period
      </Label>
    </div>
  )
}

export function RenewalStructureField({
  form,
  onChange,
}: {
  form: MembershipLevelForm
  onChange: (form: MembershipLevelForm) => void
}) {
  return (
    <FormField label="Renewal structure" htmlFor="membership-level-renewal-structure">
      <Select
        value={form.renewalStructure}
        onValueChange={(renewalStructure) => {
          const nextRenewalStructure = renewalStructure as RenewalStructure
          onChange({
            ...form,
            renewalStructure: nextRenewalStructure,
            prorateFirstPartialPeriod:
              nextRenewalStructure === 'Fixed date' ? form.prorateFirstPartialPeriod : false,
          })
        }}
      >
        <SelectTrigger id="membership-level-renewal-structure">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {renewalStructures.map((renewalStructure) => (
            <SelectItem key={renewalStructure} value={renewalStructure}>
              {renewalStructure}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FormField>
  )
}

export function RenewalTermField({
  form,
  disabled,
  error,
  onChange,
}: {
  form: MembershipLevelForm
  disabled: boolean
  error?: string
  onChange: (form: MembershipLevelForm) => void
}) {
  return (
    <FormField label="Renewal term" htmlFor="membership-level-renewal-term" error={error}>
      <Select
        value={form.renewalTerm}
        disabled={disabled}
        onValueChange={(renewalTerm) => {
          const nextRenewalTerm = renewalTerm as RenewalTerm
          onChange({
            ...form,
            renewalTerm: nextRenewalTerm,
            prorateFirstPartialPeriod:
              form.renewalStructure === 'Fixed date' ? form.prorateFirstPartialPeriod : false,
          })
        }}
      >
        <SelectTrigger id="membership-level-renewal-term">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {renewalTerms.map((renewalTerm) => (
            <SelectItem key={renewalTerm} value={renewalTerm}>
              {renewalTerm}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FormField>
  )
}
